import { Text } from "@/components/ui/Typography";
import { TextArea } from "@/components/ui/TextField";
import { cn } from "@/lib/cn";

type NoteTextareaProps = {
  value: string;
  onChange: (value: string) => void;
  placeholder: string;
  maxLength?: number;
  autoFocus?: boolean;
  /** Extra textarea classes: the two call sites differ in padding (p-4 vs p-3). */
  className?: string;
  /** Extra counter classes: the call sites differ in size and alignment. */
  counterClassName?: string;
};

/**
 * Note textarea with a "{length}/{maxLength}" counter, shared by the item observations box and the
 * per-option note dialog. Renders a fragment so each call site keeps its own wrapper.
 */
export function NoteTextarea({
  value,
  onChange,
  placeholder,
  maxLength = 200,
  autoFocus,
  className,
  counterClassName,
}: NoteTextareaProps) {
  return (
    <>
      <TextArea
        autoFocus={autoFocus}
        className={cn("h-28", className)}
        placeholder={placeholder}
        value={value}
        maxLength={maxLength}
        onChange={(event) => onChange(event.target.value)}
      />
      <Text tone="muted" tabular className={counterClassName}>
        {value.length}/{maxLength}
      </Text>
    </>
  );
}
